<template>

  <div class="tabs" >
  			<el-tabs v-model="activeName" type="card" >
          <el-tab-pane label="发票" name="first">
					<tables />
  				</el-tab-pane>

          <!-- <el-tab-pane label="历史" name="second">
        
  				</el-tab-pane> -->
  			</el-tabs>
  		</div>

</template>

<script>
import tables from './table'
export default {
    name:'finance_invoice',
    components:{tables},
    data(){
        return {
            activeName:'first',
        }
    }
}
</script>

<style scoped>
	.tabs>>>#tab-second {
		left: -20px;
		z-index: 9;
	}
</style>